import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ParkingManagementConfigurationActions } from './parking-management-configuration.actions';
import { ParkingManagementConfigurationService } from '@core/services/parkingManagementConfiguration.service';

@Injectable()
export class ParkingManagementConfigurationEffects {
  private actions$ = inject(Actions);
  private parkingManagementConfigurationService = inject(ParkingManagementConfigurationService);
  private translateService = inject(TranslateService);

  getParkingManagementList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParkingManagementConfigurationActions.loadParkingManagementConfigurationList),
      mergeMap((data) =>
        this.parkingManagementConfigurationService.getParkingManagementConfigurationMasterList(data.key, data.data).pipe(
          map((response) =>
            response.success
              ? ParkingManagementConfigurationActions.loadParkingManagementConfigurationListSuccess({ response, key: data.key })
              : ParkingManagementConfigurationActions.loadParkingManagementConfigurationListFailure({
                  error: response,
                  key: data.key,
                })
          ),
          catchError((error) =>
            of(
              ParkingManagementConfigurationActions.loadParkingManagementConfigurationListFailure({
                key: data.key,
                error: {
                  error,
                  success: false,
                  message: this.translateService.instant(
                    'Something went wrong'
                  ),
                },
              })
            )
          )
        )
      )
    )
  );

  updateParkingManagement$ = createEffect(() =>
      this.actions$.pipe(
        ofType(ParkingManagementConfigurationActions.addEditParkingManagementConfiguration),
        mergeMap((data) =>
          this.parkingManagementConfigurationService.editParkingManagementConfiguration(data.key, data.data).pipe(
            map((response) => {
              if (response.success) {
                return ParkingManagementConfigurationActions.updateParkingManagementConfigurationSuccess({
                  response,
                  key: data.key,
                });
              } else
                return ParkingManagementConfigurationActions.updateParkingManagementConfigurationFailure({
                  error: response,
                  key: data.key,
                });
            }),
            catchError((error) =>
              of(
                ParkingManagementConfigurationActions.updateParkingManagementConfigurationFailure({
                  error: {
                    error,
                    success: false,
                    message: this.translateService.instant(
                      'Something went wrong'
                    ),
                  },
                  key: data.key,
                })
              )
            )
          )
        )
      )
    );

}